import React, { lazy, useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import i18n from "@/i18n";
import { CREDIT_PRODUCT_TYPE } from '@/utils/Global';
import { SetIsShowLoginDialog } from '@/Interface';
import TwoBtnDialog from '../Common/TwoBtnDialog/TwoBtnDialog'
import "./AiTools.scss";
const AiPalette = lazy(() => import("../MakeVideo/PaletteMenu/Palette/AiPalette/AiPalette"));
const AiPanel = lazy(() => import("../MakeVideo/AiPanel/AiPanel"));

const AiTools = ({ history }) => {
    const getSelectedToolFromPath = () => {
        try {
            const path = history.location.pathname;
            const toolId = path.split('/aitools/')[1];
            return Object.values(CREDIT_PRODUCT_TYPE).includes(toolId) ? toolId : null;
        }
        catch (e) {
            return null;
        }
    };
    const currentUser = useSelector(state => state.userStore.user);
    const value = useSelector(state => state.langStore.lang);
    const [selectedAiTool, setSelectedAiTool] = useState(getSelectedToolFromPath() || null); // 초기값을 null로 설정
    const [now, setNow] = useState(null);
    const [isPaymentAlertDialogOpen, setIsPaymentAlertDialogOpen] = useState(false);

    let media = []

    const handleClickAiTool = (toolId) => {
        if (!currentUser) {
            SetIsShowLoginDialog(true);
            return;
        }

        setSelectedAiTool(toolId);
        history.push(`/studio/aitools/${toolId}`);
    };

    const handleBack = () => {
        setSelectedAiTool(null);
        history.goBack();
    };

    const setMedia = (mediaData) => {
        media = mediaData
    }

    const forceUpdate = () => {
        setNow(Date.now())
    }
    
    const handlePaymentAlertDialogOpen = () => {
        setIsPaymentAlertDialogOpen(true)
    }

    const handlePaymentAlertDialogClose = () => {
        setIsPaymentAlertDialogOpen(false)
    }

    return (
        <div className="ai-tools-container">
            {!selectedAiTool ? (
                // AI 도구 선택 화면
                <div className="ai-tools-grid">
                    <AiPalette
                        now={now}
                        enabled={true}
                        handleClickAiTool={handleClickAiTool}
                        selectedAiTool={selectedAiTool}
                        setMedia={setMedia}
                        media={media}
                        history={history} 
                        onAlertDialogOpen={handlePaymentAlertDialogOpen}
                    />
                </div>
            ) : (
                // 선택된 AI 도구 패널
                <AiPanel
                    forceUpdate={forceUpdate}
                    selectedAiTool={selectedAiTool}
                    onBack={handleBack}
                />
            )}
            
            <TwoBtnDialog
                open={isPaymentAlertDialogOpen}
                header={i18n.t("payment.alert.header")}
                onClose={handlePaymentAlertDialogClose}
                onClick={() => {
                    handlePaymentAlertDialogClose()
                    window.open("/payment","_blank")
                }}
                confirmBtnLabel={i18n.t("web.newhome.premium.section.paymentbtn")}
                cancelBtnLabel={i18n.t("global.cancel")}
            >
                <div>{i18n.t("payment.alert.body")}</div>
            </TwoBtnDialog>
        </div>
    );
};

export default AiTools;
